import React, { useEffect, useState } from 'react';
import styles from 'routes/vendorRe/pages/VendorStats.module.css';
import FlexChild from 'routes/vendorRe/containers/commons/FlexChild';
import HorizontalFlex from 'routes/vendorRe/containers/commons/HorizontalFlex';
import P from 'routes/vendorRe/containers/commons/P';
import VerticalFlex from 'routes/vendorRe/containers/commons/VerticalFlex';
import depthMove from 'routes/vendorRe/images/depth_move_icon.png';
import { requester } from 'App';

const SettlementAmount = () => {
    // 이번달 정산예정금액 변수
    // const monthSettlementAmount = totalAmount - goodsAmount;
    const date = new Date();
    const currentYear = date.getFullYear();
    const currentMonth = date.toLocaleString('ko-KR', { month: 'long' });

    const [isMounted, setMounted] = useState(false);
    const [totalAmount, setTotalAmount] = useState({});

    useEffect(() => {
        setMounted(true);
    }, [])
    useEffect(() => {
        if (isMounted) {
            requester.getVendorSettlementFee((result) => {
                
                setTotalAmount(result.data)
            })
        }

    }, [isMounted])

    return (
        <FlexChild backgroundColor="white" padding="1em" borderRadius="1em">
            <VerticalFlex>
                <FlexChild padding={"1em 0"}>
                    <HorizontalFlex>
                        <FlexChild>
                            <P weight={700} size={"max(1.3vw, 25px)"} padding="0 1em 0 0">정산 예정 금액</P>
                            <P size={"max(1vw, 20px)"} color={"#A4A4A4"}>( {currentYear}년 {currentMonth} 기준 )</P>
                        </FlexChild>
                        {/* <FlexChild justifyContent={"flex-end"}>
                            <img className={styles.depthMove} src={depthMove} alt='뎁스 이동' />
                        </FlexChild> */}
                    </HorizontalFlex>
                </FlexChild>
                <FlexChild>
                    <div className={styles.borderTop}>
                        <VerticalFlex>
                            <FlexChild padding={"1em 0"} borderTop={"1px solid #D9D9D9"}>
                                <HorizontalFlex >
                                    <FlexChild flex="3">
                                        <P size={"max(1.3vw, 25px)"} color={"#B7B7B7"}>이달 매출</P>
                                    </FlexChild>
                                    <FlexChild flex="1" justifyContent={"flex-end"}>
                                        <P weight={700} size={"max(1.3vw, 25px)"} color={"#B7B7B7"}>{totalAmount && totalAmount.totalPrice ? totalAmount.totalPrice.toLocaleString() : 0}</P>
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                            <FlexChild padding={"1em 0"}>
                                <HorizontalFlex>
                                    <FlexChild flex="3">
                                        <P size={"max(1.3vw, 25px)"} color={"#B7B7B7"}>물품 대금</P>
                                    </FlexChild>
                                    <FlexChild flex="1" justifyContent={"flex-end"}>
                                        <P weight={700} size={"max(1.3vw, 25px)"} color={"#B7B7B7"}>
                                        {totalAmount && totalAmount.totalsupplyPrice ? (`- `) + totalAmount.totalsupplyPrice.toLocaleString() : 0}
                                        </P>
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                            <FlexChild padding={"1em 0 0"}>
                                <HorizontalFlex>
                                    <FlexChild flex="3">
                                        <P size={"max(1.3vw, 25px)"} color={"#000"}>이번달 정산예정 금액</P>
                                    </FlexChild>
                                    <FlexChild flex="1" justifyContent={"flex-end"}>
                                        <P weight={700} size={"max(1.3vw, 25px)"} color={"#FE531F"}>{totalAmount && totalAmount.totalAmount ? totalAmount.totalAmount.toLocaleString() : 0}</P>
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                        </VerticalFlex>
                    </div>
                </FlexChild>
            </VerticalFlex>
        </FlexChild>
    );
};

export default SettlementAmount;